const CLOUDINARY_UPLOAD_MARKER = '/image/upload/';

// Cloudinary stores the full-resolution original (often 2MB+ per photo).
// Inserting a transformation segment makes Cloudinary serve a resized,
// auto-format (WebP/AVIF), auto-quality version from its CDN instead.
export function getOptimizedImageUrl(url, width = 600) {
  const value = String(url || '');
  const markerIndex = value.indexOf(CLOUDINARY_UPLOAD_MARKER);

  if (!value.includes('res.cloudinary.com') || markerIndex === -1) {
    return value;
  }

  const prefix = value.slice(0, markerIndex + CLOUDINARY_UPLOAD_MARKER.length);
  const rest = value.slice(markerIndex + CLOUDINARY_UPLOAD_MARKER.length);

  if (rest.startsWith('f_auto') || rest.startsWith('q_auto') || rest.startsWith('w_')) {
    return value;
  }

  return `${prefix}f_auto,q_auto,c_limit,w_${width}/${rest}`;
}
